import { Mod_parcial } from './../../../models/mod_parcial.model';
import { Component } from "@angular/core";
import {  FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-mod_parcial",
    templateUrl: "./mod_parcial.component.html",
    styleUrls: ["./mod_parcial.component.css"],
    providers: [FormService]
})

export class Mod_parcialComponent {

    public rows = [];
    public actualRow;
    public mod_parcial: Mod_parcial;
    public form;
 
    matcher = new FormService();

    constructor(){
        this.form = new FormGroup({
            supt_parcial: new FormControl(''),
            supm_parcial: new FormControl('')
        })
        if(!JSON.parse(localStorage.getItem("mod_parcial"))){
            localStorage.setItem("mod_parcial", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("mod_parcial"));

            this.form.controls['supt_parcial'].setValue(this.rows[0]?this.rows[0].supt_parcial:'')
            this.form.controls['supm_parcial'].setValue(this.rows[0]?this.rows[0].supm_parcial:'')
            
        }

    }

    add_mod_parcial(){
        localStorage.setItem("mod_parcial",JSON.stringify([]));
        this.actualRow = localStorage.getItem("mod_parcial");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            supt_parcial: this.form.value.supt_parcial,
            supm_parcial: this.form.value.supm_parcial
        })
        localStorage.setItem("mod_parcial", JSON.stringify(this.rows));
    }
  
    delete_mod_parcial(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("mod_parcial", JSON.stringify(this.rows));
            }
        }
    }  
}